import type { LoginTranslations } from "../interfaces/login";

export const loginTranslations: LoginTranslations = {
  title: "Mueve tu dinero",
  title_emphasis: "en segundos.",
  subtitle:
    "Coloca es la tecnología que te permite {emphasis} en Latinoamérica. Envía y recauda tu dinero como local, sin los altos costos y tiempos de un SWIFT.",
  subtitle_emphasis: "enviar y recibir dinero",
  google_button: "Inicia sesión con Google",
  login_button: "Iniciar sesión",
  input_user_label: "Correo",
  input_user_placeholder: "Correo",
  input_password_label: "Contraseña",
  input_password_placeholder: "Ingresa tu contraseña",
  checkbox_remember_me: "Recuérdame",
  login_account_label_prefix: "Ya tienes una cuenta?",
  login_account_label_button: "Inicia sesión",
  terms_and_conditions: "Términos y condiciones",
  // 2FA translations
  twofa_title: "Verificación en dos pasos",
  twofa_subtitle: "Ingresa el código de 6 dígitos de tu aplicación de autenticación",
  twofa_authenticator_hint: "Abre tu app de autenticación (Google Authenticator, Authy, etc.)",
  twofa_digits_counter: "{count}/6 dígitos ingresados",
  twofa_verify_button: "Verificar código",
  twofa_verifying_button: "Verificando...",
  twofa_back_link: "Volver al inicio de sesión",
  twofa_support_text: "¿No tienes acceso a tu aplicación de autenticación?",
  twofa_support_link: "Contactar soporte",
  // Change Password translations
  change_password_title: "Cambiar Contraseña",
  change_password_subtitle: "Por favor ingresa tu contraseña actual y una nueva contraseña.",
  current_password_label: "Contraseña Actual",
  current_password_placeholder: "Ingresa contraseña actual",
  new_password_label: "Nueva Contraseña",
  new_password_placeholder: "Ingresa nueva contraseña",
  confirm_password_label: "Confirmar Nueva Contraseña",
  confirm_password_placeholder: "Confirma nueva contraseña",
  change_password_button: "Cambiar Contraseña",
  back_button: "Volver",
  input_error_same_password: "La nueva contraseña no puede ser igual a la actual",
  input_error_passwords_must_match: "Las contraseñas deben coincidir",
  // Forgot password flow
  forgot_password_link: "¿Olvidaste tu contraseña?",
  fp_step_request: "Solicitar",
  fp_step_verify: "Verificar",
  fp_step_new: "Nueva contraseña",
  fp_step_done: "Listo",
  fp_request_title: "Recupera tu contraseña",
  fp_request_subtitle:
    "Ingresa el correo de tu cuenta y te enviaremos un enlace seguro para crear una nueva contraseña.",
  fp_request_email_label: "Correo electrónico",
  fp_request_email_placeholder: "tucorreo@empresa.co",
  fp_request_hint: "Te enviaremos un enlace válido por 1 hora.",
  fp_request_submit: "Enviar enlace de recuperación",
  fp_request_back: "Volver a iniciar sesión",
  fp_verify_title: "Revisa tu correo",
  fp_verify_subtitle:
    "Enviamos un enlace de recuperación a {email}. Haz clic en el botón del correo o ingresa el código abajo.",
  fp_verify_code_label: "Código de verificación",
  fp_verify_code_hint: "El código tiene 6 dígitos y expira en 1 hora.",
  fp_verify_submit: "Verificar código",
  fp_verify_resend: "¿No te llegó?",
  fp_verify_resend_cooldown: "Reenviar en {seconds}s",
  fp_verify_change_email: "Cambiar correo",
  fp_new_title: "Crea una nueva contraseña",
  fp_new_subtitle: "Verificado para {email}. Elige una contraseña que no hayas usado antes.",
  fp_new_password_label: "Nueva contraseña",
  fp_new_password_placeholder: "Mínimo 8 caracteres",
  fp_new_confirm_label: "Confirma la contraseña",
  fp_new_confirm_placeholder: "Repite la contraseña",
  fp_new_submit: "Restablecer contraseña",
  fp_new_strength: "Fortaleza",
  fp_new_strength_empty: "Muy débil",
  fp_new_strength_weak: "Débil",
  fp_new_strength_fair: "Aceptable",
  fp_new_strength_good: "Buena",
  fp_new_strength_strong: "Fuerte",
  fp_new_req_length: "Al menos 8 caracteres",
  fp_new_req_number: "Un número",
  fp_new_req_symbol: "Un símbolo especial (!@#$…)",
  fp_new_req_long: "12 caracteres o más (recomendado)",
  fp_new_match_ok: "Coinciden",
  fp_new_match_error: "Las contraseñas no coinciden.",
  fp_done_title: "Contraseña actualizada",
  fp_done_subtitle:
    "Tu contraseña fue cambiada con éxito. Ya puedes iniciar sesión con tus nuevas credenciales.",
  fp_done_go_login: "Ir a iniciar sesión",
  fp_error_invalid_code: "Código inválido o expirado.",
  fp_error_expired: "El enlace expiró. Solicita uno nuevo.",
  fp_error_weak_password: "La contraseña no cumple los requisitos mínimos.",
  fp_error_network: "No pudimos completar la solicitud. Revisa tu conexión e inténtalo de nuevo.",

  // Accept invitation
  inv_verifying_aria: "Verificando la invitación",
  inv_eyebrow: "Invitación",
  inv_title: "Te invitaron a unirte a {org}",
  inv_email_label: "Invitación para",
  inv_name_label: "Nombre completo",
  inv_name_placeholder: "Nombre y apellido",
  inv_name_required: "Ingresa tu nombre completo para aceptar la invitación.",
  inv_name_max: "Máximo 255 caracteres.",
  inv_password_label: "Crea una contraseña",
  inv_password_placeholder: "••••••••",
  inv_password_max: "Máximo 128 caracteres.",
  inv_confirm_label: "Confirma tu contraseña",
  inv_confirm_placeholder: "••••••••",
  inv_submit: "Unirme a {org}",
  inv_expiry_note: "Este enlace es de un solo uso y vence el {date}.",
  inv_footer_ignore: "¿Cuenta equivocada o invitación inesperada? Puedes ignorar este correo.",
  inv_session_notice: "Tienes sesión iniciada como {current}. Esta invitación es para {invited}.",
  inv_session_continue: "Continuar y cambiar de cuenta",
  inv_throttled: "Demasiados intentos: espera un minuto y vuelve a intentarlo.",
  inv_invalid_title: "Este enlace de invitación ya no es válido",
  inv_invalid_body:
    "Puede haber vencido o ya fue utilizado. Pide a la persona que te invitó que envíe una nueva invitación.",
  inv_go_login: "Ir a iniciar sesión",
  inv_error_title: "No pudimos verificar la invitación",
  inv_error_body: "Hubo un problema de conexión al validar el enlace. Vuelve a intentarlo en un momento.",
  inv_retry: "Reintentar",
  inv_conflict_title: "Ya existe una cuenta con este correo",
  inv_conflict_body: "La invitación para {email} corresponde a una cuenta que ya está registrada en Coloca.",
  inv_conflict_login: "Iniciar sesión",
  inv_success_title: "Bienvenido a {org}",
  inv_success_entering: "Entrando a tu panel…",
  captcha_checking: "Verificando que eres una persona…",
  captcha_failed:
    "No pudimos cargar la verificación de seguridad. Recarga la página; si sigue, desactiva el bloqueador de anuncios para este sitio.",
};
